import Footer from '../../components/Footer/Footer';
import SideBar from '../../components/SideBar/SideBar';
import NavBar1 from '../../components/Navbar1/NavBar1';
import CategoryProducts from '../../components/CategoryProducts/CategoryProducts';
const shop = () =>{
    return(
        <>
        <NavBar1 />
        <SideBar subcategory={true} shop={true}> 
            <Footer>
                <CategoryProducts shop={true}/>
           
            </Footer> 
        </SideBar>

    </>
    );
}
export default shop; 